import React, { useEffect } from 'react';
import ProjectsTech from './ProjectsTech';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import AOS from 'aos';
import 'aos/dist/aos.css'

const ProjectInfo = (props) => {
    const {name, description, image, github, site, animate} = props.project;
    const projectsTech = props.project.technologies;

    useEffect(() => {
        AOS.init({ duration: 2000})
    }, [])

    return (
        <div className="col-12 col-md-6 col-lg-4 pro-image aos-init" data-aos={animate}>
            <div className="card mt-5" id="zoom-in">
                <img src={image} className="card-img-top" alt=""/>
                <div className="card-style">
                    <h4 className="card-title">{name}</h4>
                    <p className="card-text">{description}</p>
                    <div className="d-flex justify-content-between">
                        <div className="technology">
                            {
                                projectsTech.map(tech => <ProjectsTech tech={tech} key={tech.id}></ProjectsTech>)
                            }
                        </div>
                    </div>
                </div>
                <div className="card-footer text-start ms-1">
                    <ul className="list-inline m-0 p-0">
                        <li className="list-inline-item">
                            <a href={github}target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faGithub} className="fab" /></a>
                        </li>
                        <li className="list-inline-item ms-2">
                            <a href={site}target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faExternalLinkAlt} className="fab" /></a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default ProjectInfo;